import { AdminUser } from '../sdk';
import { HQUserStatus } from '../constants';

export const setPendingUsersNameAsEmail = (users: AdminUser[]): AdminUser[] =>
  users.map((user) => {
    const userInvitedViaEmail =
      user.status === HQUserStatus.PENDING ||
      user.status === HQUserStatus.NOT_INVITED ||
      user.name === 'New Member';
    const shouldUseEmailAsName = userInvitedViaEmail || !user.name;

    return {
      ...user,
      name: shouldUseEmailAsName ? user.email : user.name,
    };
  });
